import { ContactRefreshResponseDTO, UserInfo } from '../../../../requests-module'
import logout from "@/logic/contact/logout"
import { navigateToUserInfo } from "@/router/navigate"
import defaultPhoneCodes from '@/config/defaultPhoneCodes'
import { CSEService } from '../../service/CSEService'
import { useRoute } from 'vue-router'
import setTokensInCookies from './setTokensInCookies'
import store from '@/store/BookingStore'

const refresh = async () => {
    try {
        const response: any | null = await window.tfServices.contactService.refresh();
        if (!response) throw new Error("need to logout")
        const data: ContactRefreshResponseDTO = response.data

        if (!data.tokens) throw new Error("refresh contact response has to contain an object with tokens")
        setTokensInCookies(data.tokens)

        if (!data.userInfo.phone_code) {
            const defaultPhoneCode: string = defaultPhoneCodes[window.locale.replace("_", "-")]
            data.userInfo.phone_code = defaultPhoneCode
        }

        const userInfo: UserInfo = data.userInfo

        const cseService = new CSEService(window.locale)
        if (cseService.isCSE) cseService.init()
        if (cseService.isCSE && cseService.isCGOS) { // force CSE name and surname
            if (!cseService.firstName || !cseService.lastName) throw new Error("first name and last name are mandatory for CSE")
            userInfo.first_name = cseService.firstName
            userInfo.last_name = cseService.lastName
        }

        store.commit('setLoggedUser', userInfo)
    } catch (err) {
        console.error("user refresh failed :>>", err)
        logout()
        const route = useRoute()
        if (route && route.name === 'PAYMENT') navigateToUserInfo()
    }
}

export default refresh
